<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="4"><label :for="id">{{label}}</label></b-col>
      <b-col cols="8">
        <b-form-input
          data-lpignore="true"
          :id="id"
          type="password"
          v-bind="$attrs"
          :value="value"
          @input="handleInput"
          :state="passwordState"
        />
        <b-form-invalid-feedback id="password-feedback" v-if="value"> {{ $t('requireEightLetters')}} </b-form-invalid-feedback>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: "Password",
    inheritAttrs: false,
    props: {
      label: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: false
      },
      value: {
        type: String,
        required: false
      }
    },
    computed: {
      passwordState() {
        if (!this.value) {
          return undefined
        }
        return this.value && this.value.length >= 8
      }
    },
    methods: {
      handleInput() {
        this.$emit("input", event.target.value)
      }
    }
  }
</script>
